import ManagerBooking from './ManagerBooking.container';

export default ManagerBooking;
